<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- WRAPPER -->
      <div class="crm-zalo-wrapper">
        <!-- SIDEBAR -->
        <div class="crm-sidebar" :class="sidebarClass">
          <!-- Header -->
          <div class="sidebar-header">
            <div class="sidebar-header-top">
              <div class="app-title d-flex align-items-center">
                <span class="module-dot tag-bd"></span>
                <span>Bảo dưỡng & Sửa chữa</span>
              </div>
            </div>
          </div>

          <!-- Thanh filter -->
          <div class="sidebar-filter">
            <input
              v-model.trim="searchText"
              type="text"
              class="form-control form-control-sm search-input"
              placeholder="Tìm mã phiếu, xe, tài xế..."
            />
            <div class="filter-row small">
              <select v-model="filterStatus" class="form-control form-control-sm">
                <option value="">Tất cả</option>
                <option
                  v-for="st in statusOptionsBaoDuong"
                  :key="st.value"
                  :value="st.value"
                >
                  {{ st.label }}
                </option>
              </select>
              <label class="mb-0 d-flex align-items-center ml-2">
                <input type="checkbox" v-model="onlyMyTickets" class="mr-1" />
                Chỉ phiếu tôi phụ trách
              </label>
            </div>
          </div>

          <!-- LIST PHIẾU BẢO DƯỠNG -->
          <div class="thread-list">
            <div
              v-for="t in filteredTickets"
              :key="t.id"
              :class="[
                'thread-item',
                {
                  active:
                    viewMode === 'TICKET' &&
                    activeTicket &&
                    t.id === activeTicket.id,
                  'thread-item--closed': isTicketClosed(t)
                }
              ]"
              @click="setActiveTicket(t)"
            >
              <div class="thread-left">
                <div class="thread-avatar bg-info">
                  <i class="fa fa-wrench"></i>
                </div>
              </div>
              <div class="thread-center">
                <div class="thread-top">
                  <div class="thread-title text-truncate">
                    {{ t.title }}
                  </div>
                  <div class="thread-time">
                    {{ formatTime(t.updatedAt) }}
                  </div>
                </div>
                <div class="thread-sub text-truncate">
                  #{{ t.code }} · {{ t.xeBienSo
                  }}<span v-if="t.taiXeName"> · {{ t.taiXeName }}</span>
                  <span v-if="isTicketClosed(t)" class="thread-closed-tag">
                    ĐÃ CHỐT
                  </span>
                </div>
                <div class="thread-last text-truncate">
                  <span v-if="t.messages && t.messages.length">
                    <strong>
                      {{ t.messages[t.messages.length - 1].authorName || "Hệ thống" }}:
                    </strong>
                    {{ t.messages[t.messages.length - 1].text }}
                  </span>
                  <span v-else class="text-muted">
                    Chưa có tin nhắn
                  </span>
                </div>
              </div>
              <div class="thread-right">
                <span
                  class="badge badge-status"
                  :class="statusBadgeClass('BAO_DUONG', t.status)"
                >
                  {{ shortStatus("BAO_DUONG", t.status) }}
                </span>
              </div>
            </div>

            <div
              v-if="!filteredTickets.length && !isLoadingBaoDuong && !baoDuongError"
              class="small text-muted text-center mt-3"
            >
              Không có phiếu phù hợp bộ lọc.
            </div>

            <div
              v-if="isLoadingBaoDuong"
              class="small text-muted text-center mt-3"
            >
              <span class="spinner-border spinner-border-sm"></span>
              Đang tải phiếu bảo dưỡng...
            </div>

            <div
              v-if="baoDuongError"
              class="small text-danger text-center mt-3"
            >
              {{ baoDuongError }}
            </div>
          </div>
        </div>

        <!-- MAIN CHAT -->
        <div class="crm-main">
          <!-- NÚT THU GỌN / MỞ SIDEBAR (DESKTOP + MOBILE) -->
          <div class="header-toggle-bar">
            <button
              class="btn btn-light btn-sm shadow-sm"
              @click="toggleSidebar"
            >
              <i
                class="fa"
                :class="sidebarVisible ? 'fa-chevron-left' : 'fa-bars'"
              ></i>
              <span class="ml-1">
                {{ sidebarVisible ? "Ẩn danh sách phiếu" : "Hiện danh sách phiếu" }}
              </span>
            </button>
          </div>

          <!-- CHAT PHIẾU BẢO DƯỠNG -->
          <TicketView
            v-if="viewMode === 'TICKET' && activeTicket"
            ref="ticketView"
            :active-ticket="activeTicket"
            :bao-duong-detail="activeBaoDuongDetail"

            :current-user="currentUser"
            :owners-for-active="ownersForActive"
            :members-for-active="membersForActive"
            :demo-staff="demoStaff"
            :form-driver="formDriver"
            :draft="draft"
            :module-avatar-class="moduleAvatarClass"
            :module-icon-class="moduleIconClass"
            :module-label="moduleLabel"
            :format-status="formatStatus"
            :format-currency="formatCurrency"
            :initials="initials"
            :avatar-class="avatarClass"
            :format-time="formatTime"
            :is-ticket-closed="isTicketClosed"
            @update:draft="draft = $event"
            @send="sendMessage"
            @add-me-to-members="addMeToMembers"
            @assign-me-as-owner="assignMeAsOwner"
            @assign-person="assignPerson"
            @bd-assign-to-driver="bd_assignToDriver"
            @bd-approve-cost="bd_approveCost"
            @bd-driver-send-quotation="bd_driverSendQuotation"
            @mark-paid="markPaid"
            @cancel-ticket="cancelTicket"
            @bd-send-quotation="bd_sendQuotation"
            @bd-start-repair="bd_startRepair"
            @bd-complete-repair="bd_completeRepair"
            @bd-mark-paid="bd_markPaid"
          />

          <!-- EMPTY STATE -->
          <div
            v-else
            class="empty-main d-flex align-items-center justify-content-center"
          >
            <div class="text-center text-muted">
              <i class="fa fa-comments fa-3x mb-2"></i>
              <div>Chọn một phiếu bảo dưỡng để xem luồng trao đổi.</div>
              <div class="small mt-1">
                Mỗi phiếu = 1 cuộc hội thoại riêng, chat như Zalo nhưng gắn với dữ liệu.
              </div>
            </div>
          </div>
        </div>
      </div> <!-- /crm-zalo-wrapper -->
    </div>
  </div>
</template>

<script>
import TicketView from "@/views/Slack/TicketView.vue";
import { BaoDuongXeApi } from "@/services/baoDuongXeService";
import userService from "@/services/userService";

export default {
  name: "CrmZaloMultiModuleHub",
  components: { TicketView },
  data() {
    return {
      currentUser: {
        id: null,
        displayName: "Sếp Hiếu",
        role: "ADMIN"
      },

      viewMode: "CHANNEL", // 'CHANNEL' | 'TICKET'

      filterStatus: "",
      searchText: "",
      onlyMyTickets: false,

      baoDuongTickets: [],
      isLoadingBaoDuong: false,
      baoDuongError: null,

      activeTicket: null,
      activeBaoDuongDetail: null,

      draft: "",
      formDriver: {
        cost: null,
        imageUrl: ""
      },

      demoStaff: [],
      channelMessages: {},

      // sidebar state (desktop + mobile)
      sidebarVisible: true
    };
  },
  computed: {
    sidebarClass() {
      return {
        "sidebar-hidden": !this.sidebarVisible
      };
    },

    currentUserInitials() {
      return this.initials(this.currentUser.displayName);
    },

    statusOptionsBaoDuong() {
      return [
        { value: "MOI", label: "Mới báo lỗi" },
        { value: "CHO_BAO_GIA", label: "Chờ báo giá" },
        { value: "CHO_DUYET", label: "Chờ duyệt" },
        { value: "CHO_THANH_TOAN", label: "Chờ thanh toán" },
        { value: "HOAN_THANH", label: "Hoàn thành" },
        { value: "DA_HUY", label: "Đã hủy" }
      ];
    },

    filteredTickets() {
      let list = this.baoDuongTickets.slice();

      if (this.filterStatus) {
        list = list.filter((t) => t.status === this.filterStatus);
      }

      const q = (this.searchText || "").trim().toLowerCase();
      if (q) {
        list = list.filter((t) => {
          const fields = [t.code, t.title, t.xeBienSo, t.taiXeName]
            .filter(Boolean)
            .join(" ")
            .toLowerCase();
          return fields.includes(q);
        });
      }

      if (this.onlyMyTickets) {
        const myName = this.currentUser.displayName;
        list = list.filter((t) => {
          const owners = t.owners || [];
          return owners.includes(myName);
        });
      }

      list.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
      return list;
    },

    ownersForActive() {
      if (!this.activeTicket) return [];
      return this.activeTicket.owners || [];
    },
    membersForActive() {
      if (!this.activeTicket) return [];
      return this.activeTicket.members || [];
    },

    channelCodeForModule() {
      return "bao-duong";
    },

    currentChannelMessages() {
      const list = this.channelMessages["BAO_DUONG"] || [];
      return list.slice().sort((a, b) => {
        return new Date(a.createdAt) - new Date(b.createdAt);
      });
    },

    openTicketCount() {
      return this.baoDuongTickets.filter((t) => !this.isTicketClosed(t)).length;
    }
  },
methods: {
  // ========== LOAD USER ĐANG ĐĂNG NHẬP ==========
  async loadCurrentUser() {
    try {
      const res = await userService.getMe();
      const data = res.data || {};
      const rows = data.content || data.items || data || [];
      const u = Array.isArray(rows) ? rows[0] : rows;

      if (!u) return;

      const rawRole = u.chucVuCode || u.role || "";
      let role = "ADMIN";
      const r = String(rawRole).toUpperCase();

      if (r.includes("TAI_XE") || r.includes("DRIVER")) {
        role = "TAI_XE";
      } else if (r.includes("KE_TOAN") || r.includes("ACCOUNT")) {
        role = "KE_TOAN";
      }

      this.currentUser = {
        id: u.id,
        displayName: u.hoTen || u.fullName || u.username || "Sếp Hiếu",
        role
      };
    } catch (err) {
      console.error("loadCurrentUser error", err);
    }
  },

  // ========== LOAD DANH SÁCH PHÂN CÔNG ==========
  async loadAssignableUsers() {
    try {
      const res = await userService.getAll();
      const rows = res.data || [];
      this.demoStaff = rows.map((u) => ({
        id: u.id,
        name: u.hoTen || u.fullName || u.username || "NoName"
      }));
    } catch (err) {
      console.error("loadAssignableUsers error", err);
      this.demoStaff = [];
    }
  },

  isoMinutesAgo(mins) {
    const now = new Date();
    return new Date(now.getTime() - mins * 60000).toISOString();
  },

  // ====== LOAD DATA TỪ API BẢO DƯỠNG ======
  async loadBaoDuongTickets() {
    this.isLoadingBaoDuong = true;
    this.baoDuongError = null;
    try {
      const res = await BaoDuongXeApi.listAll({
        page: 0,
        size: 100,
        sort: "ngayTao,desc"
      });
      const rows = Array.isArray(res) ? res : res.content || res.items || [];
      this.baoDuongTickets = rows.map(this.mapBaoDuongToTicket);
    } catch (err) {
      console.error("loadBaoDuongTickets error", err);
      this.baoDuongError =
        err?.message || "Không load được danh sách bảo dưỡng";
    } finally {
      this.isLoadingBaoDuong = false;
    }
  },

  mapBaoDuongToTicket(row) {
    return {
      id: row.id,
      moduleType: "BAO_DUONG",
      code: row.code || row.maBaoDuong || `BD-${row.id}`,
      xeBienSo:
        row.xeBienSo ||
        row.xeBienSoDisplay ||
        (row.xe && row.xe.bienSo) ||
        "",
      taiXeName:
        row.taiXeName || row.tenTaiXe || row.tenNguoiBaoLoi || "",
      loaiBaoDuong: this.mapLoaiBaoDuong(row.loaiBaoDuong),
      title:
        row.noiDungCongViec ||
        row.noiDungSuCo ||
        `Phiếu bảo dưỡng #${row.id}`,
      status: row.trangThai || "MOI",
      deXuat: row.giaDeXuat || row.chiPhiDeXuat || null,
      daDuyet: row.giaDuocDuyet || row.chiPhiDuocDuyet || null,
      updatedAt:
        row.updatedAt ||
        row.thoiDiemCapNhatCuoi ||
        row.thoiDiemDuyet ||
        row.thoiDiemTao ||
        new Date().toISOString(),
      owners: row.owners || (row.tenNguoiDuyet ? [row.tenNguoiDuyet] : []),
      members:
        row.members ||
        [row.tenNguoiTao, row.tenNguoiDuyet].filter(Boolean),
      messages: row.messages || []
    };
  },

  mapLoaiBaoDuong(code) {
    if (!code) return "";
    switch (code) {
      case "DINH_KY":
      case "DINH_KY_10K":
        return "Bảo dưỡng định kỳ";
      case "SU_CO_DOT_XUAT":
        return "Sự cố đột xuất / SOS";
      default:
        return code;
    }
  },

  initDemoChannels() {
    const isoAgo = (mins) => this.isoMinutesAgo(mins);
    this.channelMessages = {
      BAO_DUONG: [
        {
          id: "c-bd-1",
          type: "SYSTEM",
          text: "Hệ thống: đồng bộ danh sách phiếu bảo dưỡng từ module Bảo dưỡng.",
          createdAt: isoAgo(21)
        }
      ]
    };
  },

  // ===== COMMON HELPERS =====
  initials(name) {
    if (!name) return "";
    return name
      .split(" ")
      .map((p) => p[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  },
  formatRole(role) {
    if (role === "ADMIN") return "Admin / Điều phối";
    if (role === "TAI_XE") return "Tài xế";
    if (role === "KE_TOAN") return "Kế toán";
    return role;
  },
  moduleLabel() {
    return "Bảo dưỡng";
  },
  moduleIconClass() {
    return "fa fa-wrench";
  },
  moduleAvatarClass() {
    return "bg-info";
  },
  formatStatus(_moduleType, st) {
    switch (st) {
      case "MOI":
        return "Mới báo lỗi";
      case "CHO_BAO_GIA":
        return "Chờ báo giá";
      case "CHO_DUYET":
        return "Chờ duyệt";
      case "CHO_THANH_TOAN":
        return "Chờ thanh toán";
      case "HOAN_THANH":
        return "Hoàn thành";
      case "DA_HUY":
        return "Đã hủy";
      default:
        return st;
    }
  },
  shortStatus(_moduleType, st) {
    if (st === "MOI") return "Mới";
    if (st === "CHO_BAO_GIA") return "Báo giá";
    if (st === "CHO_DUYET") return "Duyệt";
    if (st === "CHO_THANH_TOAN") return "Thanh toán";
    if (st === "HOAN_THANH") return "xong";
    if (st === "DA_HUY") return "Hủy";
    return st;
  },
  formatCurrency(v) {
    if (!v && v !== 0) return "-";
    return Number(v).toLocaleString("vi-VN") + " đ";
  },
  formatTime(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    const hh = String(d.getHours()).padStart(2, "0");
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${hh}:${mm}`;
  },
  statusBadgeClass(_moduleType, st) {
    if (st === "MOI") return "badge-light";
    if (st === "CHO_BAO_GIA") return "badge-warning";
    if (st === "CHO_DUYET") return "badge-info";
    if (st === "CHO_THANH_TOAN") return "badge-danger";
    if (st === "HOAN_THANH") return "badge-success";
    if (st === "DA_HUY") return "badge-secondary";
    return "badge-light";
  },

  isTicketClosed(ticket) {
    if (!ticket) return false;
    const st = ticket.status;
    return st === "HOAN_THANH" || st === "DA_HUY";
  },

  // ===== VIEW SWITCH =====
  openGeneralChannel() {
    this.viewMode = "CHANNEL";
    this.activeTicket = null;
    this.draft = "";
    this.$nextTick(this.scrollToBottom);
  },

  async setActiveTicket(t) {
    this.viewMode = "TICKET";
    this.activeTicket = t;
    this.draft = "";
    this.activeBaoDuongDetail = null;

    console.log("[Hub] setActiveTicket, ticket:", t);

    // 1. Load chi tiết bảo dưỡng
    if (t.moduleType === "BAO_DUONG") {
      try {
        const detail = await BaoDuongXeApi.getById(t.id);
        console.log("[Hub] BaoDuong detail:", detail);
        this.activeBaoDuongDetail = detail;
      } catch (err) {
        console.error("Lỗi load chi tiết:", err);
        this.activeBaoDuongDetail = null;
      }
    }

    // 2. Load chat messages
    try {
      const msgs = await BaoDuongXeApi.getChat(t.id);
      console.log("[Hub] chat msgs:", msgs);
      this.activeTicket.messages = Array.isArray(msgs) ? msgs : [];
    } catch (e) {
      console.error("load chat error", e);
      this.activeTicket.messages = this.activeTicket.messages || [];
    }

    // 3. Mobile: chọn phiếu xong thì ẩn sidebar
    if (window.innerWidth < 992) {
      this.sidebarVisible = false;
    }

    this.$nextTick(this.scrollToBottom);
  },

  toggleSidebar() {
    this.sidebarVisible = !this.sidebarVisible;
  },

  scrollToBottom() {
    if (this.viewMode === "CHANNEL" && this.$refs.channelView) {
      this.$refs.channelView.scrollToBottom();
    } else if (this.viewMode === "TICKET" && this.$refs.ticketView) {
      this.$refs.ticketView.scrollToBottom();
    }
  },

  // ===== CHAT SEND =====
  async sendMessage() {
    const text = (this.draft || "").trim();
    if (!text) return;

    const nowIso = new Date().toISOString();

    if (this.viewMode === "TICKET" && this.activeTicket) {
      try {
        const saved = await BaoDuongXeApi.sendChat(this.activeTicket.id, {
          text
        });
        if (saved) {
          this.activeTicket.messages.push(saved);
        } else {
          this.activeTicket.messages.push({
            id: `${this.activeTicket.id}-${(this.activeTicket.messages || []).length + 1}`,
            type: "USER",
            authorName: this.currentUser.displayName,
            authorRole: this.currentUser.role,
            text,
            createdAt: nowIso
          });
        }
      } catch (e) {
        console.error("send chat error", e);
      }

      this.activeTicket.updatedAt = nowIso;
      this.draft = "";
      this.$nextTick(this.scrollToBottom);
      return;
    }

    if (!this.activeTicket) return;

    const msg = {
      id: `${this.activeTicket.id}-${(this.activeTicket.messages || []).length + 1}`,
      type: "USER",
      authorName: this.currentUser.displayName,
      authorRole: this.currentUser.role,
      text,
      createdAt: nowIso
    };
    this.activeTicket.messages = this.activeTicket.messages || [];
    this.activeTicket.messages.push(msg);
    this.activeTicket.updatedAt = msg.createdAt;
    this.draft = "";
    this.$nextTick(this.scrollToBottom);
  },

  pushSystem(text) {
    if (!this.activeTicket) return;
    this.activeTicket.messages = this.activeTicket.messages || [];
    const msg = {
      id: `${this.activeTicket.id}-${this.activeTicket.messages.length + 1}`,
      type: "SYSTEM",
      text,
      createdAt: new Date().toISOString()
    };
    this.activeTicket.messages.push(msg);
    this.activeTicket.updatedAt = msg.createdAt;
    this.$nextTick(this.scrollToBottom);
  },

  logToChannelFromTicket(actionText) {
    if (!this.activeTicket) return;
    const t = this.activeTicket;
    const list =
      this.channelMessages["BAO_DUONG"] ||
      (this.channelMessages["BAO_DUONG"] = []);
    const msg = {
      id: `BAO_DUONG-c-${list.length + 1}`,
      type: "SYSTEM",
      text: `[${t.code}] ${actionText}`,
      createdAt: new Date().toISOString()
    };
    list.push(msg);
  },

  // ====== FLOW BẢO DƯỠNG KHAI BÁO THEO API SERVICE ======

  // Gửi báo giá (từ form ở TicketView -> emit 'bd-send-quotation')
  async bd_sendQuotation(payload) {
    if (!this.activeTicket) return;
    const id = this.activeTicket.id;

    try {
      await BaoDuongXeApi.submitBaoGia(id, {
        garaDeXuat: payload.garaDeXuat,
        giaDeXuat: payload.giaDeXuat,
        anhBaoGiaUrl: payload.anhBaoGiaUrl || null
      });

      this.activeTicket.garaDeXuat = payload.garaDeXuat;
      this.activeTicket.deXuat = payload.giaDeXuat;
      this.activeTicket.anhBaoGiaUrl = payload.anhBaoGiaUrl || null;
      this.activeTicket.status = "CHO_DUYET";
      this.activeTicket.updatedAt = new Date().toISOString();

      this.pushSystem("Đã gửi báo giá từ gara / tài xế.");
      this.logToChannelFromTicket("đã gửi báo giá.");
    } catch (e) {
      console.error("bd_sendQuotation error", e);
      alert("Gửi báo giá thất bại, vui lòng thử lại.");
    }
  },

  // Admin duyệt báo giá
  async bd_approveCost() {
    if (!this.activeTicket) return;
    const id = this.activeTicket.id;

    try {
      await BaoDuongXeApi.duyetBaoGia(id);

      this.activeTicket.status = "DA_DUYET";
      this.activeTicket.daDuyet =
        this.activeTicket.daDuyet || this.activeTicket.deXuat;
      this.activeTicket.updatedAt = new Date().toISOString();

      this.pushSystem("Admin đã duyệt báo giá.");
      this.logToChannelFromTicket("đã duyệt báo giá.");
    } catch (e) {
      console.error("bd_approveCost error", e);
      alert("Duyệt báo giá thất bại.");
    }
  },

  // Bắt đầu sửa chữa
  async bd_startRepair() {
    if (!this.activeTicket) return;
    const id = this.activeTicket.id;

    try {
      await BaoDuongXeApi.batDauSuaChua(id);

      this.activeTicket.status = "DANG_SUA";
      this.activeTicket.updatedAt = new Date().toISOString();

      this.pushSystem("Đã bắt đầu sửa chữa.");
      this.logToChannelFromTicket("đã bắt đầu sửa chữa.");
    } catch (e) {
      console.error("bd_startRepair error", e);
      alert("Không bắt đầu sửa được.");
    }
  },

  // Hoàn thành sửa chữa
  async bd_completeRepair(payload) {
    if (!this.activeTicket) return;
    const id = this.activeTicket.id;

    try {
      await BaoDuongXeApi.hoanThanhSuaChua(id, {
        odoHoanThanh: payload.odoHoanThanh,
        chiPhiThucTe: payload.chiPhiThucTe,
        bienLaiUrl: payload.bienLaiUrl
      });

      this.activeTicket.status = "CHO_THANH_TOAN";
      this.activeTicket.odoHoanThanh = payload.odoHoanThanh;
      this.activeTicket.chiPhiThucTe = payload.chiPhiThucTe;
      this.activeTicket.bienLaiUrl = payload.bienLaiUrl;
      this.activeTicket.updatedAt = new Date().toISOString();

      this.pushSystem("Tài xế / gara đã xác nhận hoàn thành sửa chữa.");
      this.logToChannelFromTicket("đã báo hoàn thành sửa chữa.");
    } catch (e) {
      console.error("bd_completeRepair error", e);
      alert("Gửi xác nhận hoàn thành thất bại.");
    }
  },

  // Xác nhận thanh toán
  async bd_markPaid(note) {
    if (!this.activeTicket) return;
    const id = this.activeTicket.id;
    const ghiChu = note || "";

    try {
      await BaoDuongXeApi.xacNhanThanhToan(id, ghiChu);

      this.activeTicket.status = "HOAN_THANH";
      this.activeTicket.ghiChuThanhToan = ghiChu;
      this.activeTicket.updatedAt = new Date().toISOString();

      this.pushSystem("Kế toán / Admin đã đánh dấu ĐÃ THANH TOÁN.");
      this.logToChannelFromTicket("đã đánh dấu đã thanh toán.");
    } catch (e) {
      console.error("bd_markPaid error", e);
      alert("Đánh dấu thanh toán thất bại.");
    }
  },

  // Hủy phiếu
  async cancelTicket() {
    if (!this.activeTicket) return;
    const id = this.activeTicket.id;

    if (!confirm("Hủy phiếu bảo dưỡng này?")) return;

    const lyDoHuy =
      prompt("Nhập lý do hủy (tùy chọn):", "Hủy từ màn hình CRM Bảo dưỡng") ||
      "Hủy từ màn hình CRM Bảo dưỡng";

    try {
      await BaoDuongXeApi.huyPhieu(id, lyDoHuy);

      this.activeTicket.status = "DA_HUY";
      this.activeTicket.updatedAt = new Date().toISOString();

      this.pushSystem(`Phiếu bảo dưỡng đã bị hủy. Lý do: ${lyDoHuy}`);
      this.logToChannelFromTicket("đã hủy phiếu bảo dưỡng này.");
    } catch (e) {
      console.error("cancelTicket error", e);
      alert("Hủy phiếu thất bại.");
    }
  }
}

  ,
  async mounted() {
    await this.loadCurrentUser();
    this.initDemoChannels();
    this.loadBaoDuongTickets();
    this.loadAssignableUsers();
    this.$nextTick(this.scrollToBottom);
  }
};
</script>

<style>
/* ============ SHELL TỔNG ============ */
.crm-zalo-wrapper {
  display: flex;
  background: linear-gradient(135deg, #eef2ff, #f8fafc);
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(15, 23, 42, 0.12);
  min-height: 540px;
  max-height: calc(100vh - 140px);
}

/* ============ SIDEBAR ============ */
.crm-sidebar {
  width: 320px;
  display: flex;
  flex-direction: column;
  background: rgba(248, 250, 252, 0.96);
  border-right: 1px solid rgba(148, 163, 184, 0.35);
  backdrop-filter: blur(8px);
  min-height: 0;
  transition: width 0.2s ease, opacity 0.2s ease;
}

/* trạng thái sidebar ẩn (desktop) */
.sidebar-hidden {
  width: 0;
  min-width: 0;
  opacity: 0;
  overflow: hidden;
}

.sidebar-header {
  padding: 10px 14px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.2);
}
.sidebar-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.app-title {
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #0f172a;
}
.module-dot {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  display: inline-block;
  margin-right: 6px;
}
.tag-bd {
  background: linear-gradient(135deg, #0ea5e9, #22c55e);
}

/* FILTER BAR */
.sidebar-filter {
  padding: 6px 10px 8px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.18);
}
.search-input {
  border-radius: 999px;
  font-size: 12px;
  padding-left: 12px;
  border-color: rgba(148, 163, 184, 0.6);
}
.search-input:focus {
  box-shadow: 0 0 0 0.15rem rgba(59, 130, 246, 0.25);
}
.filter-row {
  display: flex;
  align-items: center;
  margin-top: 4px;
}
.filter-row select {
  font-size: 12px;
  border-radius: 999px;
}
.filter-row label {
  font-size: 11px;
  color: #6b7280;
}

/* LIST PHIẾU */
.thread-list {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: 4px 6px 6px;
}

.thread-item {
  display: flex;
  padding: 7px 8px;
  margin-bottom: 4px;
  cursor: pointer;
  border-radius: 12px;
  background: transparent;
  transition: background 0.12s ease, transform 0.08s ease, box-shadow 0.12s ease;
}
.thread-item:hover {
  background: rgba(226, 232, 240, 0.8);
  transform: translateY(-1px);
}
.thread-item.active {
  background: #2563eb;
  box-shadow: 0 6px 15px rgba(37, 99, 235, 0.35);
}
.thread-item--closed {
  opacity: 0.65;
}

.thread-left {
  margin-right: 8px;
}
.thread-avatar {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(circle at 10% 20%, #38bdf8 0, #1d4ed8 70%);
  color: #fff;
  font-size: 16px;
}

/* CENTER TEXT */
.thread-center {
  flex: 1;
  min-width: 0;
}
.thread-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.thread-title {
  font-weight: 600;
  font-size: 13px;
  color: #0f172a;
}
.thread-time {
  font-size: 11px;
  color: #9ca3af;
  margin-left: 6px;
}
.thread-sub {
  font-size: 11px;
  color: #6b7280;
}
.thread-last {
  font-size: 11px;
  margin-top: 1px;
  color: #4b5563;
}

/* Khi active -> chữ trắng */
.thread-item.active .thread-title,
.thread-item.active .thread-sub,
.thread-item.active .thread-last,
.thread-item.active .thread-time {
  color: #e5e7eb;
}

.thread-closed-tag {
  display: inline-flex;
  align-items: center;
  margin-left: 4px;
  padding: 0 6px;
  border-radius: 999px;
  font-size: 10px;
  background: rgba(15, 23, 42, 0.06);
  color: #6b7280;
}
.thread-item.active .thread-closed-tag {
  background: rgba(15, 23, 42, 0.35);
  color: #e5e7eb;
}

/* STATUS PILL */
.thread-right {
  display: flex;
  align-items: center;
}
.badge-status {
  font-size: 10px;
  border-radius: 999px;
  padding: 3px 8px;
  border: 0;
}
.badge-status.badge-light {
  background-color: #e5e7eb;
  color: #374151;
}
.badge-status.badge-warning {
  background: #fbbf24;
  color: #111827;
}
.badge-status.badge-info {
  background: #38bdf8;
  color: #0f172a;
}
.badge-status.badge-danger {
  background: #ef4444;
  color: #f9fafb;
}
.badge-status.badge-success {
  background: #22c55e;
  color: #f9fafb;
}
.badge-status.badge-secondary {
  background: #6b7280;
  color: #f9fafb;
}
.thread-item.active .badge-status {
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.25);
}

/* EMPTY / LOADING */
.thread-list .text-center {
  font-size: 12px;
}

/* ============ MAIN CHAT AREA ============ */
.crm-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  background: radial-gradient(circle at top left, #eff6ff 0, #eff6ff 50%, #e5e7eb 100%);
}
.header-toggle-bar {
  padding: 6px 10px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.25);
  background: rgba(255, 255, 255, 0.96);
  z-index: 2;
}
.empty-main {
  flex: 1;
  min-height: 0;
  display: flex;
}

/* Reuse header class cho TicketView luôn */
.chat-header {
  padding: 10px 14px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.25);
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(8px);
}

/* Scrollbar */
.chat-messages::-webkit-scrollbar,
.thread-list::-webkit-scrollbar {
  width: 6px;
}
.chat-messages::-webkit-scrollbar-thumb,
.thread-list::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.9);
  border-radius: 999px;
}
.chat-messages::-webkit-scrollbar-track,
.thread-list::-webkit-scrollbar-track {
  background: transparent;
}

/* Badge lớn ở header */
.badge-status-lg {
  font-size: 12px;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
}

/* ============ RESPONSIVE ============ */
@media (max-width: 991.98px) {
  .crm-zalo-wrapper {
    flex-direction: column;
    max-height: none;
    border-radius: 0.75rem;
  }

  .crm-sidebar {
    width: 100%;
    max-height: 42vh;
    transition: max-height 0.2s ease, opacity 0.2s ease;
  }

  /* Khi ẩn trên mobile: thu theo chiều cao */
  .sidebar-hidden {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    border-bottom: none;
  }

  .thread-list {
    max-height: 32vh;
  }

  .crm-main {
    width: 100%;
    min-height: 58vh;
    border-top: 1px solid rgba(148, 163, 184, 0.25);
    display: flex;
    flex-direction: column;
  }

  .crm-main > .ticket-view,
  .crm-main > .empty-main {
    flex: 1 1 auto;
    min-height: 0;
  }
}

@media (max-width: 575.98px) {
  .sidebar-filter {
    padding-bottom: 6px;
  }
  .filter-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .filter-row label {
    margin-left: 0;
    margin-top: 4px;
  }
}
</style>
